import CwLoadModules from '@customjs/module-loader.js';
import AccordionHS from 'accordion.hs';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
        }

        const offices_contact_page = document.querySelector('.select-office');
        if (offices_contact_page) {
            this.loadLocationsWidget(offices_contact_page);
            offices_contact_page.addEventListener('change', () => this.loadLocationsWidget(offices_contact_page));
        }

        // Initialize accordion for locations
        this.accordionLocations();
    },

    accordionLocations() {
		const accordions = document.querySelectorAll('.accordion');
		new AccordionHS(accordions, {});

		const footer__accordion = document.querySelector(
			'.footer-contact__accordion'
		);

		if (!footer__accordion) return;

		const footer_map = document.querySelector('.footer-contact__map figure');
		const mobileImageTag = footer_map.querySelector('.mobile-map');
		const tabletImageTag = footer_map.querySelector('.tablet-map');
		const desktopImageTag = footer_map.querySelector('.desktop-map');
		const mapURL = footer_map.querySelector('.location-url');
		const officeHoursModal = document.querySelector('.opening-hours');

		/**
		 * This event listener will handle the accordion functionality for the footer accordion.
		 */

		footer__accordion.addEventListener('click', (event) => {
			if (event.target.className.includes('accordion__item-title')) {
				const currentTab = event.target;
				const directionURL =
					currentTab.parentNode.querySelector('.btn-direction')?.href;
				const [mImage, tImage, dImage] = [
					currentTab.dataset.mobilemapurl,
					currentTab.dataset.tabletmapurl,
					currentTab.dataset.desktopmapurl,
				];

				mapURL.href = directionURL ? directionURL : '#';

				if (window.matchMedia('(max-width: 767px)').matches) {
					mobileImageTag.src = !mImage ? dImage : mImage;
				} else if (window.matchMedia('(max-width: 1199px)').matches) {
					tabletImageTag.src = !tImage ? dImage : tImage;
				} else {
					desktopImageTag.src = dImage;
				}
			}
		});

		// This handler will be in charge of displaying the opening hours for the selected location.
		footer__accordion.addEventListener('click', (event) => {
			if (event.target.className.includes('cw-modal')) {
				const currentModalButton = event.target;
				const [monday, tuesday, wednesday, thursday, friday, saturday, sunday] =
					[
						currentModalButton.dataset.openingHoursMonday,
						currentModalButton.dataset.openingHoursTuesday,
						currentModalButton.dataset.openingHoursWednesday,
						currentModalButton.dataset.openingHoursThursday,
						currentModalButton.dataset.openingHoursFriday,
						currentModalButton.dataset.openingHoursSaturday,
						currentModalButton.dataset.openingHoursSunday,
					];
				const openingHours = [
					monday,
					tuesday,
					wednesday,
					thursday,
					friday,
					saturday,
					sunday,
				];

				const days = document.body.classList.contains('spanish-page') ? [
					'Lunes',
					'Martes', 
					'Miércoles',
					'Jueves',
					'Viernes',
					'Sábado',
					'Domingo'
				] : [
					'Monday',
					'Tuesday',
					'Wednesday', 
					'Thursday',
					'Friday',
					'Saturday',
					'Sunday'
				];

				const openingHoursRows = openingHours.map((hour, index) => {
					if (hour) {
						return `<tr><td class="day">${days[index]}</td><td class="time"><span>${hour}</span></td></tr>`;
					} else {
						return '';
					}
				});
				console.log(openingHoursRows);
				const HTMLtable = `
					<table>
                        <tbody>
							${openingHoursRows.join('')}
						</tbody>
					</table>
				`;

				officeHoursModal.innerHTML = HTMLtable;
			}
		});
	},

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    contact_us_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="phone ctm-no-swap" aria-label="Phone">${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a class="btn btn-footer btn-directions" href="${directionURL}" target="_blank" aria-label="Directions Link">Directions</a>
                   <button class="btn btn-footer btn-office-hours cw-modal" data-cw-target="#hoursModal" id="office-hours">Office Hours</button>
               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Directions Link"><img src="${footer_map}" alt="${firmName}" /></a></figure>` :
                    '';

                const contactMapHTML = contact_us_map ?
                `<figure><a href="${directionURL}" target="_blank" aria-label="Directions Link"><img src="${contact_us_map}" alt="${firmName}" /></a></figure>` :
                '';

                const address = `
               <address>
                   ${address1HTML}<br>
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}
               ${officeInfoButtons}
               ${contactMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Load Locations for Contact Page
     */
    async loadLocationsWidget(locationID_Widget) {
        if (locationID_Widget) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID_Widget.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    contact_us_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                    is_spanish,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span><br>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="phone ctm-no-swap" aria-label="Phone">${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a class="btn btn-footer btn-directions" href="${directionURL}" target="_blank" aria-label="Directions Link">${is_spanish ? 'Direcciones' : 'Directions'}</a>
                   <button class="btn btn-footer btn-office-hours cw-modal" data-cw-target="#hoursModal" id="office-hours">${is_spanish ? 'Horario de Oficina' : 'Office Hours'}</button>
               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Directions Link"><img src="${footer_map}" alt="${firmName}" /></a></figure>` :
                    '';

                const contactMapHTML = contact_us_map ?
                `<figure><a href="${directionURL}" target="_blank" aria-label="Directions Link"><img src="${contact_us_map}" alt="${firmName}" /></a></figure>` :
                '';

                const address = `
               <address>
                   ${address1HTML}<br>
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}
               ${officeInfoButtons}
               ${contactMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice; console.log(is_spanish);
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;